import RaceStatus from 'SharedComponents/race_status';

export default (sportEventPathId) => ({
  364: RaceStatus,
}[sportEventPathId] || null);
